<script>
import auth from "@/api/auth.js";
import { msalInstance } from "vue-msal-browser";
export default {
  name: "Callback",
  async beforeMount() {
    await msalInstance.handleRedirectPromise().catch((err) => {
      msalInstance.logoutRedirect();
    });
    this.$router.replace({
      path: auth.getFromUri(),
    });
  },
  render() {},
}
</script>